export default {
  resetZoom: 'Reset zoom',
  exitFullscreen: 'Exit fullscreen',
  fullscreen: 'Fullscreen',
  showPoints: 'Show points',
  showNotes: 'Show notes',
  showExpertView: 'Show Expert View',
  leaveNote: 'Leave a note (Alt + Click)',
  zoomMode: 'Zoom mode',
  overFlowMenu: 'Additional functions',
  markersMode: 'Markers mode',
};
